import { render, staticRenderFns } from "./ZoomView.vue?vue&type=template&id=63170786&scoped=true&"
import script from "./ZoomView.vue?vue&type=script&lang=js&"
export * from "./ZoomView.vue?vue&type=script&lang=js&"
import style0 from "./ZoomView.vue?vue&type=style&index=0&id=63170786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63170786",
  null
  
)

export default component.exports